/**
 * Shared category color palette used across cashflow charts and budget UI.
 * Extracted so both features reference the same source of truth.
 */

export const CATEGORY_PALETTE = [
  "#ede4da", "#918d8d", "#636167", "#aeaeb2", "#a94949",
  "#ca5954", "#e56f4b", "#e39347", "#eeb551", "#e8c65b",
  "#bda351", "#8b9150", "#557d55", "#446350", "#3e554c",
  "#8bb0ad", "#769fa6", "#668da9", "#5c699f", "#5a5888",
  "#7c6da2", "#947a9d", "#bc87a5", "#d9a6a6", "#b0978a",
];

export function hash(str: string, digits: number): string {
  digits = digits || 6;
  const m = Math.pow(10, digits + 1) - 1;
  const phi = Math.pow(10, digits) / 2 - 1;
  let n = 0;
  for (let i = 0; i < str.length; i++) {
    n = (n + phi * str.charCodeAt(i)) % m;
  }
  return n.toString();
}

export const stringToColor = (str: string): string => {
  const idNum = parseInt(hash(str, 4));
  return CATEGORY_PALETTE[idNum % CATEGORY_PALETTE.length];
};
